import React from "react";
import _ from "lodash";
import imagesCss from "../../../assets/styles/images/images.module.scss";
import { UploadIcon } from "../../../assets/styles/images/icons";
import { Button } from "semantic-ui-react";
import FileUploader from "../../shared/fileUploader";

const ImagesUploader = React.forwardRef(
  (
    {
      setImageState,
      selectedImageIndex,
      setSelectedImageIndex,
    },
    ref
  ) => {
    const handleUpload = () => {
      const fileInput = ref?.current?.querySelector("input[type='file']");
      fileInput?.click();
    };

    const handleFileChange = (filePath) => {
      setImageState((prev) => {
        const clonedState = _.cloneDeep(prev);
        const imageOptions =
          clonedState?.data?.template_data?.image_options || [];

        if (
          selectedImageIndex !== null &&
          selectedImageIndex >= 0 &&
          selectedImageIndex < imageOptions.length
        ) {
          imageOptions[selectedImageIndex].image_url = filePath;
        } else {
          imageOptions.push({
            image_url: filePath,
            keywords: [],
            size: null,
            type: null,
          });
        }

        return clonedState;
      });

      setSelectedImageIndex(null);
    };

    const handleImageMeta = (field, value) => {
      setImageState((prev) => {
        const cloned = _.cloneDeep(prev);
        const imageOptions = cloned.data.template_data.image_options;

        const targetIndex =
          selectedImageIndex !== null ? selectedImageIndex : imageOptions.length - 1;

        if (targetIndex >= 0 && targetIndex < imageOptions.length) {
          imageOptions[targetIndex][field] = value;
        }

        return cloned;
      });
    };

    const handleImageType = (type) => handleImageMeta("type", type);
    const handleImageSize = (size) => handleImageMeta("size", size);

    return (
      <div className={imagesCss.uploadArea}>
        <div ref={ref} className={imagesCss.fileUploader}>
          <FileUploader
            handleChange={handleFileChange}
            imageType={handleImageType}
            imageSize={handleImageSize}
          />
        </div>
        <label className={imagesCss.uploadLabel}>
          <UploadIcon />
          <Button onClick={handleUpload} className={imagesCss.uploadButton}>
            Upload Images
          </Button>
        </label>
      </div>
    );
  }
);

export default ImagesUploader;
